import {Table} from "antd";
import {t} from "i18next";
import Helper from "../../core/Helper";

export default function CashRegisterSummary({data = 'TRY'})
{

    return (
        <>
            <Table
                size={'small'}
                dataSource={data}
                rowKey={'name'}
                pagination={false}
                columns={[
                    {dataIndex: 'name', key: 'name', title: t('Payment Method'),},
                    {dataIndex: 'totalRevenues', key: 'totalRevenues', title: t('Revenues'), render: (text, row) => Helper.Currency.format(row?.summary?.totalRevenues, {currency: row?.summary?.currency})},
                    {dataIndex: 'totalExpense', key: 'totalExpense', title: t('Expense'), render: (text, row) => Helper.Currency.format(row?.summary?.totalExpense, {currency: row?.summary?.currency})},
                    {dataIndex: 'total', key: 'total', title: t('Net'), render: (text, row) => Helper.Currency.format(row?.summary?.total, {currency: row?.summary?.currency})},
                ]}
            />
        </>
    )
}